import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const TOAST_BASE =
  "group toast flex items-center gap-3 w-full rounded-xl p-4 shadow-lg border"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: `${TOAST_BASE} bg-card text-card-foreground border-border`,
          success: `${TOAST_BASE} bg-card text-card-foreground border-border`,
          error: `${TOAST_BASE} bg-destructive/90 text-destructive-foreground border-destructive`,
          warning: `${TOAST_BASE} bg-amber-500/90 text-white border-amber-600`,
          info: `${TOAST_BASE} bg-card text-card-foreground border-border`,
          title: "text-sm font-medium",
          description: "text-sm opacity-80",
          actionButton:
            "rounded-md px-3 py-1 text-sm bg-primary text-primary-foreground",
          cancelButton:
            "rounded-md px-3 py-1 text-sm bg-muted text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
